var _path, _g, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconMunicipalTaxes810Ee731E1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 19.943L19.946 8.997l1.061 1.061-10.946 10.946z",
    fill: "#231f20"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#ffc700"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 11.07,
    cy: 11.01,
    r: 2.1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 19.12,
    cy: 18.96,
    r: 2.1
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15,28A13,13,0,1,1,28,15,13,13,0,0,1,15,28ZM15,3.5A11.5,11.5,0,1,0,26.5,15,11.51,11.51,0,0,0,15,3.5Z",
    fill: "#231f20"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMunicipalTaxes810Ee731E1);
export default __webpack_public_path__ + "static/media/icon_municipal_Taxes_810ee731e1.b991f34b3f59f4f9390b851501e7ecea.svg";
export { ForwardRef as ReactComponent };